import { LenderProfile, SendOcaLinkInput } from '@trnsact/trnsact-shared-types';
import { SelectOption } from 'global';
import { SendApplicationFormValues } from '../types';
import { SendApplicationPortalConfig } from 'modules/portalConfigurations/sendApplication/types';

export const getLenderProfilesWithOcaOptions = (
  lenderProfiles: LenderProfile[],
  portalConfigurationConfig?: SendApplicationPortalConfig
): SelectOption<string>[] => {
  const excludedLenderProfileIds = portalConfigurationConfig?.excludedLenderProfileIds ?? [];
  return (
    lenderProfiles
      ?.filter(({ lenderProfileId }) => !excludedLenderProfileIds.includes(lenderProfileId))
      .map(({ lenderProfileId, name }) => ({ label: name!, value: lenderProfileId })) ?? []
  );
};

export const formatFormValuesToSendOcaLinkPayload = (formValues: SendApplicationFormValues): SendOcaLinkInput => {
  return {
    lenderProfileId: formValues.lenderProfileId,
    sendMethod: formValues.sendMethod,
    contactDetails: formValues.contactDetails,
    equipment: formValues.equipment,
  };
};
